import dayjs from "dayjs";

export function convertDateTimeToDate(datetimeString) {
    // Create a new Date object from the datetime string
    const dateTime = new Date(datetimeString);

    // Get the date components
    const year = dateTime.getFullYear();
    const month = (dateTime.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = dateTime.getDate().toString().padStart(2, '0');

    // Create the date string in the desired format (YYYY-MM-DD)
    const dateString = `${year}-${month}-${day}`;

    return dateString;
}

export function getFirstDayOfMonth(dayjsObject) {
    if (!dayjsObject) {
        return null;
    }
    if (!dayjsObject.isValid()) {
        return null;
    }
    return dayjsObject.startOf('month').format('YYYY-MM-DD');
}

export function getLastDayOfMonth(dayjsObject) {
    if (!dayjsObject) {
        return null;
    }
    if (!dayjsObject.isValid()) {
        return null;
    }
    return dayjsObject.endOf('month').format('YYYY-MM-DD');
}

export function convertYearMonth(yearMonth) {
    // Parse the inputDate using dayjs
    const parsedDate = dayjs(yearMonth, 'YYYYMM');

    // Format the parsed date to 'MMM ´YY'
    const formattedYearMonth = parsedDate.format('MMM ´YY');

    return formattedYearMonth.toString();
};

export function convertYearQuarter(yearQuarter) {
    // Parse the year and quarter using substring
    const parsedYear = yearQuarter.substring(2, 4);
    const parsedQuarter = yearQuarter.substring(4, 5);

    // Format the parsed date to 'QQ ´YY'
    const formattedYearQuarter = `Q${parsedQuarter} ´${parsedYear}`;

    return formattedYearQuarter.toString();
};

export function transformToDayjs(dateValue) {
    if (dateValue === null) {
        return null
    }

    return dayjs(dateValue)
}

export function addMonthsToDate(dayjsObject, numMonths) {
    if (!dayjsObject) {
        return null;
    }
    if (!dayjsObject.isValid()) {
        return null;
    }

    // Add the specified number of months
    const newdayjsObject = dayjsObject.add(numMonths, 'month');

    return newdayjsObject;
}

export function isToday(dateString) {
    const today = new Date();  // Get today's date
    const dateToCompare = new Date(dateString);  // Convert the string to a Date object

    // Reset the time to compare only the date part
    today.setHours(0, 0, 0, 0);
    dateToCompare.setHours(0, 0, 0, 0);

    return today.getTime() === dateToCompare.getTime();  // Compare the two dates
}

export function isYesterday(dateString) {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);  // Set to yesterday's date
    
    const dateToCompare = new Date(dateString);  // Convert the string to a Date object

    // Reset the time to compare only the date part
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);
    dateToCompare.setHours(0, 0, 0, 0);

    return yesterday.getTime() === dateToCompare.getTime();  // Compare if the date is yesterday
}